var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAddress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.5492C14.8667 14.5492 16.38 13.0359 16.38 11.1692C16.38 9.30245 14.8667 7.78917 13 7.78917C11.1333 7.78917 9.62 9.30245 9.62 11.1692C9.62 13.0359 11.1333 14.5492 13 14.5492Z",
    stroke: "#EE2A7B",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92168 9.1975C6.05584 -0.184167 19.955 -0.173333 22.0783 9.20833C23.3242 14.7117 19.9008 19.37 16.9 22.2517C14.7225 24.3533 11.2775 24.3533 9.08918 22.2517C6.09918 19.37 2.67584 14.7008 3.92168 9.1975Z",
    stroke: "#001860",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAddress);
export default __webpack_public_path__ + "static/media/my-address.4e6e1184.svg";
export { ForwardRef as ReactComponent };